// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5de71787","455":"21f0c6e2","977":"edc1582d"}[chunkId] + ".chunk.js";
};